import { render, staticRenderFns } from "./editUser.vue?vue&type=template&id=22ab632c&scoped=true&"
import script from "./editUser.vue?vue&type=script&lang=js&"
export * from "./editUser.vue?vue&type=script&lang=js&"
import style0 from "./editUser.vue?vue&type=style&index=0&id=22ab632c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ab632c",
  null
  
)

export default component.exports